(function(Affirm, $, undefined) {
  
  var bindUIActions = function() {

    $('[data-affirm-modal-trigger]').on('click', function(e) {
      e.preventDefault();
      affirm.ui.openModal();
    })

    if (queryParams.affirmModal === "true") {
      affirm.ui.openModal();
    }

    if (queryParams.affirmFeature === "true") {
      Scroll.smoothScroll($('#affirm'), $('.site-header').outerHeight(), 0);
      affirm.ui.openModal();
    }
  }

  Affirm.init = function() {
    affirm.ui.ready(function() {
      bindUIActions();
    })
  }

}(window.Affirm = window.Affirm || {}, jQuery));